// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { fetchResources } from './redux/dataSlice';
import EmbedDashboard from './pages/EmbedDashboard';

const AppContent = () => {
  const dispatch = useDispatch();
  const { currentLanguage } = useLanguage();

  React.useEffect(() => {
    dispatch(fetchResources(currentLanguage));
  }, [dispatch, currentLanguage]);

  return (
    <Routes>
      <Route path="/recursero-ami-embed/:lang" element={<EmbedDashboard />} />
      <Route path="/recursero-ami-embed" element={<EmbedDashboard />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;